if (!customElements.get('delivery-cutoff')) {
  class DeliveryCutoff extends HTMLElement {
    connectedCallback() {
      this.update();
      this.timer = setInterval(() => this.update(), 60000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    londonHour() {
      const parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/London',
        hour: 'numeric',
        hourCycle: 'h23',
      }).formatToParts(new Date());
      return parseInt(parts.find((part) => part.type === 'hour').value, 10);
    }

    update() {
      const cutoff = parseInt(this.dataset.cutoffHour, 10);
      const isAfter = this.londonHour() >= cutoff;
      this.classList.toggle('is-after', isAfter);
      this.classList.toggle('is-before', !isAfter);
      this.classList.add('is-ready');
    }
  }
  customElements.define('delivery-cutoff', DeliveryCutoff);
}
